import { render, staticRenderFns } from "./ToolComparison.vue?vue&type=template&id=743d5480&"
import script from "./ToolComparison.js?vue&type=script&lang=js&"
export * from "./ToolComparison.js?vue&type=script&lang=js&"
import style0 from "./ToolComparison.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports